import { CODEABLE_CONCEPT_FRAGMENT, ExtensionFragment } from '@/services/graphql';
import { gql } from '@bariendo/lib/graphql';
import { Resource } from '@medplum/fhirtypes';

export type OrganizationContactFragment = {
  name?: {
    family?: string;
    given?: string[];
  };
  telecom?: {
    system?: string;
    value?: string;
  };
  extension?: ExtensionFragment[];
};

export type PartnerOrganizationsResource = Resource & {
  resourceType?: 'Organization';
  id?: string;
  name?: string;
  type?: {
    coding?: {
      display?: string;
    }[];
  };
  telecom?: {
    system?: string;
    value?: string;
    rank?: number;
  }[];
  contact?: OrganizationContactFragment[];
};

export const ORGANIZATION_CONTACT_FRAGMENT = gql`
  fragment OrganizationContactFragment on OrganizationContact {
    name {
      family
      given
    }
    telecom {
      system
      value
    }
    extension {
      url
      valueAttachment {
        url
      }
    }
  }
`;

export const ORGANIZATIONS_QUERY = gql`
  ${CODEABLE_CONCEPT_FRAGMENT}
  ${ORGANIZATION_CONTACT_FRAGMENT}
  query OrganizationList($type: String, $name: String) {
    OrganizationList(type: $type, _filter: $name) {
      resourceType
      id
      name
      type {
        ...CodeableConceptFragment
      }
      telecom {
        system
        value
        rank
      }
      contact {
        ...OrganizationContactFragment
      }
    }
  }
`;
